import { useRef } from "react";
import { Heading, Stack, Text } from "@chakra-ui/react";

import CustomWrapper from "components/Chakra/CustomWrapper";
import { cards, variants } from "./translation";
import ContactForm from "./ContactForm";
import Footer from "../Footer";
import VariantCard from "./VariantCard";
import Banner from "./Banner";
import Header from "./Header";
import ServicesGrid from "./ServicesGrid";
import MetaHead from "components/MetaHead";

const IdealniNajemce = () => {
  const sectionRef = useRef<HTMLDivElement>(null);

  const handleScrollToSection = () => {
    if (sectionRef.current) {
      const windowHeight = window.innerHeight;
      const sectionHeight = sectionRef.current.clientHeight;
      const scrollTo =
        sectionRef.current.offsetTop - (windowHeight - sectionHeight) / 2;

      window.scrollTo({
        top: scrollTo,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <MetaHead
        title="Pronájem bez starostí a bez rizika | Ideální nájemce"
        description=" Ideální nájemce bere všechny rizika pronájmu na sebe. Garantujeme vám nájem na den přesně, stav bytu i kvalitní podnájemníky. Postaráme se o vše od A do Z."
      />
      <CustomWrapper maxW="1440px" px={{ base: "16px", md: "64px" }}>
        <Header handleScrollToSection={handleScrollToSection} />

        <Heading mt="120px" mb="16px" textAlign="center">
          Garantujeme vám příjem z pronájmu. Ať se děje cokoliv…
        </Heading>

        <Stack
          wrap="wrap"
          w="100%"
          margin="0 auto"
          justifyContent="center"
          pt="60px"
          direction="row"
          gap="12px"
          rowGap="48px"
        >
          {cards.map((item, index) => (
            <Stack
              key={index}
              flex="1 1 0"
              minW="360px"
              maxW="360px"
              position="relative"
              boxShadow="0 4px 8px rgba(161, 161, 161, 0.5)"
              borderRadius="4px"
              padding="70px 40px 40px"
              gap="11px"
              _hover={{
                "& .animatedTitle": {
                  color: "ud-primary",
                  transition: "color 0.30s ease",
                },
              }}
            >
              <Text
                className="animatedTitle"
                color="ud-primary-300"
                fontSize="63px"
                fontWeight="700"
                position="absolute"
                top="-2%"
              >
                {item.counter}
              </Text>
              <Text color="#23007d" fontWeight="700" fontSize="1.5rem">
                {item.title}
              </Text>
              <Text>{item.description}</Text>
            </Stack>
          ))}
        </Stack>

        <ContactForm forwardedRef={sectionRef} />

        <Stack align="center" spacing="48px" mt={{ base: "40px", md: "60px" }}>
          <Heading>O váš pronájem se postaráme od A do Z</Heading>
          <ServicesGrid />
        </Stack>

        <Heading
          mt={{ base: "40px", md: "60px" }}
          mb="32px"
          display="flex"
          justifyContent="center"
        >
          Varianty služby
        </Heading>
        <Stack
          align="center"
          wrap="wrap"
          direction="row"
          justify="center"
          spacing={0}
          gap="24px"
          sx={{
            "@media screen and (max-width: 768px)": {
              "& :nth-of-type(2)": {
                order: -1,
              },
            },
          }}
        >
          {variants.map((item, index) => (
            <VariantCard
              key={index}
              index={index}
              handleScrollToSection={handleScrollToSection}
              item={item}
            />
          ))}
        </Stack>

        <Banner handleScrollToSection={handleScrollToSection} />
      </CustomWrapper>
      <Footer />
    </>
  );
};

export default IdealniNajemce;
